const hotels = {
  accommodation: "Apgyvendinimas", // translated 
  hotel: "Viešbutis", // translated 
  hotels: "Viešbučiai", // translated 
  back: "Atgal", // translated 
  rooms: "Kambariai", // translated 
  viewPictures: "Žiūrėti paveikslėlius", // translated 
  showMore: "Rodyti daugiau", // translated 
  bookingInformation: "Užsakymo informacija", // translated 
  importantInformation: "Svarbi informacija", // translated
  cancellationPolicy: "Atšaukimo politika", // translated 
  from: "Nuo", // translated 
  to: "Į", // translated 
  cancellationIs: "atšaukimas yra", // translated 
  free: "Laisvas", // translated 
  chargeableWithFeeOf: "apmokestinamas su mokesčiu", // translated 
  prebook: "Išankstinė knyga", // translated 
  guests: "Svečiai", // translated 
  payment: "Mokėjimas", // translated 
  byClicking: "Spustelėjus", // translated 
  next: "Kitas", // translated 
  youAreAgreeingToOur: "jūs sutinkate su mūsų", // translated 
  termsAndConditions: "Taisyklės ir sąlygos", // translated 
  previous: "Ankstesnis", // translated 
  cancel: "Atšaukti", // translated 
  mealPlan: "Maisto planas", // translated 
  roomType: "Kambario tipas", // translated 
  description: "apibūdinimas", // translated 
  readLess: "Skaitykite Mažiau", // translated 
  readMore: "Skaityti daugiau", // translated 
  facilities: "Įranga", // translated 
  viewLess: "Žiūrėti mažiau", // translated 
  viewMore: "Peržiūrėti daugiau", // translated 
  less: "mažiau", // translated 
  more: "daugiau", // translated 
  notAvailable_short: "N/A", // translated 
  backToHotelList: "Grįžti į viešbučių sąrašą", // translated 
  viewOnMap: "Žiūrėti žemėlapyje", // translated 
  sleeps: "Miega", // translated 
  adults: "Suaugusieji", // translated 
  yearsOld: "metų", // translated 
  type: "Tipas", // translated 
  bedding: "Patalynė", // translated 
  selectRoom: "Pasirinkite kambarį", // translated 
  selectRooms: "Pasirinkite Kambariai", // translated 
  city: "Miestas", // translated 
  checkIn: "Įsiregistruoti", // translated 
  checkOut: "Išsiregistruokite", // translated 
  date: "Data", // translated 
  dates: "Datos", // translated 
  persons: "Asmenys", // translated 
  stillOnTrialQuestionToUpgrade:
    "Oi! Panašu, kad vis dar naudojate bandomąją narystę. Norėdami atlikti užsakymus, turite būti patvirtintas narys. Ar norėtumėte naujovinti dabar?", // translated 
  stillOnTrialQuestionToUpgradeNonElligib:
    "Oi! Panašu, kad dar nesate užsiprenumeravęs. Norėdami atlikti užsakymus, turite būti patvirtintas narys. Ar norėtumėte naujovinti dabar?", // translated 
  completeProfile: "Pirmiausia užpildykite savo vartotojo profilį", // translated 
  upgrade: "Patobulinti", // translated 
  close: "Uždaryti", // translated 
  viewDetails: "Išsamiau", // translated 
  name: "vardas", // translated 
  rating: "Įvertinimas", // translated 
  budget: "Biudžetas", // translated 
  orderBy: "Rūšiuoti pagal", // translated 
  priceLowestFirst: "Kaina (pirmiausia mažiausia)", // translated 
  priceHighestFirst: "Kaina (pirmiausia aukščiausia)", // translated 
  ratingLowestFirst: "Įvertinimas (pirmiausia žemiausias)", // translated 
  ratingHighestFirst: "Įvertinimas (pirmas aukščiausias)", // translated 
  starRatingAndPrice: "Įvertinimas žvaigždutėmis ir kaina", // translated 
  biggestSavingsFirst: "Didžiausios santaupos pirmiausia", // translated 
  select: "Pasirinkite", // translated 
  reset: "Nustatyti iš naujo", // translated 
  apply: "Taikyti", // translated 
  filterBy: "Filtruoti pagal", // translated 
  myProfile: "Mano profilis", // translated 
  login: "Prisijungti", // translated 
  roomOnly: "Tik kambarys", // translated 
  bedAndBreakfast: "Nakvynė ir pusryčiai", // translated 
  halfBoard: "Dalinis maitinimas", // translated 
  fullBoard: "Pilnas maitinimas", // translated 
  allInclusive: "Viskas įskaičiuota", // translated 
  filter: "Filtras", // translated 
  mapView: "Žemėlapio vaizdas", // translated 
  results: "rezultatus", // translated 
  listView: "Sarašas", // translated 
  newSearch: "Nauja paieška", // translated 
  editSearch: "Redaguoti paiešką", // translated 
  all: "Visi", // translated 
  multiple: "Daugkartinis", // translated 
  editProfile: "Redaguoti profilį", // translated 
  backToHotelsList: "Atgal į viešbučių sąrašą", // translated 
  roomName: "Kambario pavadinimas", // translated 
  mealType: "Maisto tipas", // translated 
  freeCancellation: "Nemokamas ATŠAUKIMAS", // translated 
  yes: "Taip", // translated 
  no: "Nr", // translated 
  filters: "Filtrai", // translated 
  cancellationNonRefundable: "Pinigai už atšaukimą negrąžinami", // translated 
  hotelRating: "Viešbučio įvertinimas", // translated 
  any: "Bet koks", // translated 
  off: "Išjungta", // translated 
  performNewSearch: "Atlikite naują paiešką", // translated 
};



export default hotels;
